(function () {
  var TXT = {
    fr: 'Nous utilisons des cookies pour une navigation plus fluide sur le site, pour mesurer sa fréquentation et pour vous montrer nos pierres sur d’autres sites. Vous pouvez accepter ou refuser, et changer d’avis à tout moment.',
    en: 'We use cookies for smoother browsing on our site, to measure its traffic and to show you our stones on other websites. You can accept or decline, and change your mind at any time.',
    es: 'Usamos cookies para una navegación más fluida en el sitio, para medir su audiencia y para mostrarle nuestras piedras en otros sitios. Puede aceptar o rechazar, y cambiar de opinión en cualquier momento.'
  };
  var lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var text = TXT[lang] || TXT.fr;

  function rewrite() {
    var p = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
    if (!p || p.getAttribute('data-johya') === '1') return !!p;
    var link = p.querySelector('#shopify-pc__banner__body-policy-link');
    p.textContent = text + ' ';
    if (link) p.appendChild(link);
    p.setAttribute('data-johya', '1');
    return true;
  }

  if (rewrite()) return;
  var obs = new MutationObserver(function () { if (rewrite()) obs.disconnect(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 20000);
})();
